import { BulkOperationError } from 'graphql/generated/graphqlTypes';

export interface SelectedUser {
  id: string;
  name: string;
}

export interface BulkUserActionFailure {
  visitorId: string;
  name: string;
  reason: string;
}

export const getFailedVisitorIds = (errors: BulkOperationError[]) =>
  errors.reduce<string[]>(
    (failedVisitorIds, { visitorId }) =>
      failedVisitorIds.includes(visitorId) ? failedVisitorIds : [...failedVisitorIds, visitorId],
    []
  );

export const getBulkUserActionFailures = (
  errors: BulkOperationError[],
  selectedUsers: SelectedUser[],
  unknownReason: string
): BulkUserActionFailure[] => {
  const selectedUsersById = new Map(selectedUsers.map((selectedUser) => [selectedUser.id, selectedUser]));

  return errors.map(({ visitorId, message }) => ({
    visitorId,
    name: selectedUsersById.get(visitorId)?.name ?? visitorId,
    reason: message || unknownReason
  }));
};
